<template>
  <div :class='classes'>
    <div class="flex-none text-xs font-bold text-center text-white m-1 w-16">{{label}}</div>
    <value-or-variable class='flex-auto' v-model='value' type="number" :variables='variables' :toggle-position="togglePosition" @change='onChange'>
      <template #default="{}">
        <slot name='default' />
      </template>
    </value-or-variable>
  </div>
</template>
<script>
export default {
  props:{
    value:{
      type:[Number, Boolean, String, Object],
      required:true
    },
    label:{
      type:String,
      required:true
    },
    togglePosition:{
      type:String,
      default:'row'
    },
    variables:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  methods:{
    onChange(nv, ov) {
      console.log('novwl change', nv, ov);
      this.$emit('change', nv, ov);
    }
  },
  computed:{
    classes() {
      const classes = ['flex', 'w-full', 'items-center', 'justify-center'];
      if (this.togglePosition === 'row') {
        classes.push('flex-col');
      }
      return classes;
    }
  }
  
}
</script>

